/* Aihan Perfumes – homepage interactions */
(function () {
  function initTabs(root) {
    root.querySelectorAll('[data-ah-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ahReady) return;
      wrap.dataset.ahReady = '1';
      var buttons = wrap.querySelectorAll('[data-ah-tab]');
      var panels = wrap.querySelectorAll('[data-ah-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-selected', b === btn); });
          panels.forEach(function (p) { p.hidden = p.dataset.ahPanel !== btn.dataset.ahTab; });
        });
      });
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-ah-slider]').forEach(function (wrap) {
      if (wrap.dataset.ahReady) return;
      wrap.dataset.ahReady = '1';
      var track = wrap.querySelector('.ah-slider');
      var dots = wrap.querySelector('.ah-dots');
      if (!track || !dots) return;
      function build() {
        dots.innerHTML = '';
        var pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.05));
        if (pages < 2) return;
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          (function (i) { b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }); })(i);
          dots.appendChild(b);
        }
        update();
      }
      function update() {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.querySelectorAll('button').forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
      window.addEventListener('resize', build);
      build();
    });
  }

  function initHero(root) {
    root.querySelectorAll('[data-ah-hero]').forEach(function (hero) {
      if (hero.dataset.ahReady) return;
      hero.dataset.ahReady = '1';
      var slides = hero.querySelectorAll('.ah-hero__slide');
      var dots = hero.querySelectorAll('.ah-hero__dots button');
      if (slides.length < 2) return;
      var i = 0, timer;
      var delay = parseInt(hero.dataset.speed || '6', 10) * 1000;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function play() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); }
      function stop() { clearInterval(timer); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
      var prev = hero.querySelector('[data-ah-hero-prev]');
      var next = hero.querySelector('[data-ah-hero-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
      if (next) next.addEventListener('click', function () { go(i + 1); play(); });
      // pause while hovered / focused
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', play);
      // swipe on touch screens
      var x0 = null, y0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(dx < 0 ? i + 1 : i - 1); play(); }
        x0 = y0 = null;
      }, { passive: true });
      play();
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-ah-gallery]').forEach(function (g) {
      if (g.dataset.ahReady) return;
      g.dataset.ahReady = '1';
      var imgs = g.querySelectorAll('.ah-feature__main img');
      var thumbs = g.querySelectorAll('.ah-feature__thumbs button');
      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === k); });
          thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === k); });
        });
      });
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.ah-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initReels(root) {
    root.querySelectorAll('.ah-reel video').forEach(function (v) {
      v.muted = true;
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* Card "Add to cart" – ajax add, then open Dawn's cart drawer (falls back to /cart) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-ah-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var body = {
      id: form.querySelector('[name=id]').value,
      quantity: 1
    };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message || 'Could not add to cart'); return; }
        if (drawer && drawer.renderContents && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  /* PDP sticky add-to-cart bar */
  function initSticky(root) {
    var bar = root.querySelector('[data-ah-sticky]');
    if (!bar || bar.dataset.ahReady) return;
    bar.dataset.ahReady = '1';
    // Dawn may re-render the product form, so always look the button up fresh.
    function getBtn() { return document.querySelector('.product-form__submit'); }
    var mainBtn = getBtn();
    if (!mainBtn) return;
    var ticking = false;
    function update() {
      ticking = false;
      var b = getBtn();
      var f = document.querySelector('.ah-footer, .footer');
      if (!b) return;
      var pastButton = b.getBoundingClientRect().bottom < 0;
      var nearFooter = f && f.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-visible', pastButton && !nearFooter);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
    bar.querySelector('[data-ah-sticky-btn]').addEventListener('click', function () {
      var b = getBtn();
      if (!b) return;
      if (b.disabled) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      b.click();
    });
    // keep price + button state in sync with the selected variant
    var priceSrc = document.querySelector('[id^="price-template"]');
    var priceDst = bar.querySelector('[data-ah-sticky-price]');
    var label = bar.querySelector('[data-ah-sticky-label]');
    function sync() {
      var b = getBtn();
      if (priceSrc && priceDst) priceDst.innerHTML = priceSrc.innerHTML;
      if (label && b) label.textContent = b.disabled ? (b.textContent.trim() || 'Sold out') : label.dataset.default;
    }
    var info = document.querySelector('product-info') || document.body;
    new MutationObserver(sync).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    sync();
  }

  /* Tester bundle picker: exactly N testers before add to cart */
  function initPicker(root) {
    var picker = root.querySelector('[data-ah-picker]');
    if (!picker || picker.dataset.ahReady) return;
    picker.dataset.ahReady = '1';
    var size = parseInt(picker.dataset.size, 10) || 3;
    var inputs = picker.querySelectorAll('[data-ah-picker-input]');
    var hidden = picker.querySelector('[data-ah-picker-value]');
    var count = picker.querySelector('[data-ah-picker-count]');
    var msg = picker.querySelector('[data-ah-picker-msg]');
    var form = document.querySelector('product-form form');
    // note: form.id would return the <input name="id"> inside Shopify's product form
    var formId = form && form.getAttribute('id');
    if (formId) hidden.setAttribute('form', formId);
    function update() {
      var chosen = Array.prototype.filter.call(inputs, function (i) { return i.checked; });
      inputs.forEach(function (i) { i.disabled = !i.checked && chosen.length >= size; });
      hidden.value = chosen.map(function (i) { return i.value; }).join(', ');
      count.textContent = chosen.length;
      picker.classList.toggle('is-complete', chosen.length === size);
      if (chosen.length === size) msg.hidden = true;
    }
    inputs.forEach(function (i) { i.addEventListener('change', update); });
    // block add to cart until the set is complete (runs before Dawn's submit handler)
    document.addEventListener('submit', function (e) {
      if (!form || e.target !== form) return;
      var n = Array.prototype.filter.call(inputs, function (i) { return i.checked; }).length;
      if (n !== size) {
        e.preventDefault();
        e.stopImmediatePropagation();
        msg.hidden = false;
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
    update();
  }

  function init(root) {
    root = root || document;
    initPicker(root);
    initTabs(root); initSliders(root); initHero(root); initGallery(root); initReveal(root); initReels(root); initSticky(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
